// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a96e1184","453":"d67d66de"}[chunkId] + ".chunk.js";
};